import PropTypes from "prop-types";

import { strCode } from "../../../consts";
import { formatUtils } from "./utils/formatUtils";

import { BatchCreate } from "../../../components";
import { ImportedUsersTableColumns } from "./ImportedUsersTableColumns";

import usersTemplate from "../../../assets/files/usersTemplate.csv";

const UserBatchCreateModal = ({ active, setActive, onSubmit }) => {
  return (
    <BatchCreate
      active={active}
      setActive={setActive}
      csvExampleName={"usersTemplate"}
      csvExampleUrl={usersTemplate}
      successInfo={strCode.SUCCESSFUL_USERS_IMPORT_INFO}
      failedInfo={strCode.FAILED_USERS_IMPORT_INFO}
      onSubmit={onSubmit}
      formatParsedData={formatUtils.formatParsedData}
      formatRecords={formatUtils.formatRecords}
      ImportedRecordsTableColumns={ImportedUsersTableColumns}
    />
  );
};

UserBatchCreateModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default UserBatchCreateModal;
